import { isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { ProductItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 *
 *
 *
 *
 */
export const VARIATION_PRELOAD_COUNT = {
    /*                                                    */
    initial: 18,
    /*                                                                                */
    'initial-lite': 0,
    /*                                                                  */
    reload: 8,
} as const;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mergePreloadedVariations(original: TileListItem[], preloaded: ProductItem[]): TileListItem[] {
    if (!preloaded.length) return original;

    const byLocalListPosition = new Map<number, ProductItem>();
    for (const item of preloaded) {
        if (!item.variations.length) continue;
        byLocalListPosition.set(item.localListPosition, item);
    }

    if (!byLocalListPosition.size) return original;

    return original.map((item) => {
        if (!isProductItem(item)) return item;
        if (item.variations.length) return item;
        const preloadedItem = byLocalListPosition.get(item.localListPosition);
        if (!preloadedItem) return item;
        return {
            ...preloadedItem,
            localListPosition: item.localListPosition,
            actualListPosition: item.actualListPosition,
            originPosition: item.originPosition,
        };
    });
}
